export default __webpack_public_path__ + "locales/el-GR/ChangePasswordDialog.json?hash=a2fff2f382022619953bcf09992e138e";